const parseObjectToQuery = (params) => {
	return Object.keys(params)
		.map(key => {
			if (key === 'q') {
				return `${key}=${encodeURIComponent(params[key])}`;
			} else {
				return `${key}=${params[key]}`;
			}
		})
		.join('&');
};

export default parseObjectToQuery;